import {application} from "./application"

import SwiperController from "./swiper_controller"
import KeyValueRepeaterController from "./repeater_controller"
import FilterController from "./filter_controller";
import ImageUploadController from "./image-upload_controller"
import PopupController from "./popup_controller"
import PortalController from "./portal_controller"

application.register("swiper", SwiperController)
application.register("repeater", KeyValueRepeaterController)
application.register("filter", FilterController)
application.register("image-upload", ImageUploadController)
application.register("popup", PopupController)
application.register("portal", PortalController)